import { Card, CardContent } from "@/components/ui/card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

type Props = {
  title: string;
  value: string;
  description: string;
  formula: string;
};

const AdminStatCard = ({ title, value, description, formula }: Props) => (
  <Card className="border border-gray-200">
    <CardContent className="p-5">
      <div className="flex items-start justify-between gap-2">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-1.5">
            <h3 className="text-sm font-medium text-gray-500">{title}</h3>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button aria-label="Información" className="text-gray-400 hover:text-gray-600">
                    <Info className="w-3.5 h-3.5" />
                  </button>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="max-w-xs">
                  <p className="text-xs font-semibold mb-1">{description}</p>
                  <p className="text-xs font-mono text-gray-300">{formula}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <p className="text-3xl font-bold text-palomma-secondary">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default AdminStatCard;
